import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor() { }

  successNoti(message: string) {
    Swal.fire({
      title: 'Success!',
      text: message,
      icon: 'success',
      toast: true,
      position: 'top-end',
      timer: 3000,
      timerProgressBar: true,
      showConfirmButton: false,
      background: '#d4edda',
      color: '#155724',
      iconColor: '#155724'
    });
  }

  errorNoti(message: string) {
    Swal.fire({
      title: 'Error!',
      text: message,
      icon: 'error',
      toast: true,
      position: 'top-end',
      timer: 3000,
      timerProgressBar: true,
      showConfirmButton: false,
      background: '#f8d7da',
      color: '#721c24',
      iconColor: '#721c24',
      customClass: {
        popup: 'custom-toast-popup' // Add a custom class for the toast popup
      }
    });
  }

  warningNoti(message: string) {
    Swal.fire({
      title: 'Warning!',
      // text: 'This action might have consequences.',
      text: message,
      icon: 'warning',
      toast: true,
      position: 'top-end',
      timer: 3000,
      timerProgressBar: true,
      showConfirmButton: false,
      background: '#fff3cd',
      color: '#856404',
      iconColor: '#856404'
    });
  }

  infoNoti(message: string) {
    Swal.fire({
      title: 'Info!',
      text: message,
      // text: 'This is some information for you.',
      icon: 'info',
      toast: true,
      position: 'top-end',
      timer: 3000,
      timerProgressBar: true,
      showConfirmButton: false,
      background: '#cce5ff',
      color: '#004085',
      iconColor: '#004085'
    });
  }

  confirmResetPassword(confirmCallback: () => void, cancelCallback?: () => void) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-danger",
        cancelButton: "btn btn-secondary"
      },
      buttonsStyling: true
    });

    swalWithBootstrapButtons.fire({
      title: "Are you sure?",
      text: "You want to reset password!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, reset it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
      allowOutsideClick: false
    }).then((result) => {
      if (result.isConfirmed) {
        confirmCallback();
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        if (cancelCallback) {
          cancelCallback();
        }
      }
    });
  }

  // Add confirmation dialog with callbacks for confirm/cancel
  confirmDelete(confirmCallback: () => void, cancelCallback?: () => void) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-danger",
        cancelButton: "btn btn-secondary"
      },
      buttonsStyling: true
    });

    swalWithBootstrapButtons.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
      allowOutsideClick: false
    }).then((result) => {
      if (result.isConfirmed) {
        confirmCallback();
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        if (cancelCallback) {
          cancelCallback();
        }
      }
    });
  }

  confirmInactive(confirmCallback: () => void, cancelCallback?: () => void) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-danger",
        cancelButton: "btn btn-secondary"
      },
      buttonsStyling: true
    });

    swalWithBootstrapButtons.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, inactive it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true,
      allowOutsideClick: false
    }).then((result) => {
      if (result.isConfirmed) {
        confirmCallback();
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        if (cancelCallback) {
          cancelCallback();
        }
      }
    });
  }

  confirmApprovedAgent(confirmCallback: () => void, cancelCallback?: () => void) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-secondary"
      },
      buttonsStyling: true
    });

      swalWithBootstrapButtons.fire({
        title: "Are you sure?",
        text: "You want to approve this agent?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes, approve it!",
        cancelButtonText: "No, cancel!",
        reverseButtons: true,
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          confirmCallback();
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          if (cancelCallback) {
            cancelCallback();
          }
        }
      });
    }

      confirmRejectedAgent(
      confirmCallback: (remark: string) => void,
      cancelCallback?: () => void
    ) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-secondary'
        },
        buttonsStyling: true
      });

    swalWithBootstrapButtons.fire({
      title: 'Are you sure?',
      text: 'You want to reject this agent?',
      icon: 'question',
      input: 'textarea',
      inputLabel: 'Rejection Remark',
      inputPlaceholder: 'Enter reason for rejection...',
      inputAttributes: {
        maxlength: '250'
      },
      showCancelButton: true,
      confirmButtonText: 'Yes, reject it!',
      cancelButtonText: 'No, cancel!',
      reverseButtons: true,
      allowOutsideClick: false,
      // --- ADDED VALIDATION ---
      inputValidator: (value) => {
        if (!value || !value.trim()) {
          return 'You must provide a remark to reject the agent!';
        }
        return null;
      }
    }).then((result) => {
      if (result.isConfirmed) {
        const remark = result.value; // ✅ remark text
        confirmCallback(remark);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        cancelCallback?.();
      }
    });
  }


  confirmation(confirmCallback: () => void, cancelCallback?: () => void): void {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-secondary'
      },
      buttonsStyling: true
    });

    swalWithBootstrapButtons.fire({
      title: 'Are you sure?',
      text: 'You are about to assign this task. Are you sure you want to proceed?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, assign it!',
      cancelButtonText: 'No, cancel!',
      reverseButtons: true,
      allowOutsideClick: false
    }).then((result) => {
      if (result.isConfirmed) {
        confirmCallback();  // Task is assigned
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        if (cancelCallback) {
          cancelCallback();  // Action canceled
        }
      }
    });
  }


  // action: string = ''
  showError(message: string): Promise<any> {
    return Swal.fire({
      title: 'Error!',
      text: message,
      icon: 'error',
      confirmButtonText: 'Retry',
      // confirmButtonText: action == 'list' ? 'Retry' : 'Ok',
      // showCancelButton: action == 'list'
      showCancelButton: true
    })
  }

  ForbiddenError(message: string): Promise<any> {
    return Swal.fire({
      title: 'Error!',
      text: message,
      icon: 'error',
      // confirmButtonText: 'Retry',
      // confirmButtonText: action == 'list' ? 'Retry' : 'Ok',
      // showCancelButton: action == 'list'
      showCancelButton: true
    })
  }

  showSkip(message: string): Promise<any> {
  return Swal.fire({
    title: 'Error!',
    text: message,
    icon: 'error',
    
    showConfirmButton: true,
    confirmButtonText: 'Retry',
    // confirmButtonColor: '#319d8e',

    showDenyButton: true,
    denyButtonText: 'Skip Liveness',
    // denyButtonColor: '#c97d24',

    showCancelButton: true,
    cancelButtonText: 'Cancel',
    // cancelButtonColor: '#6c757d'
  });
}

  Error(message: string): Promise<any> {
    return Swal.fire({
      title: 'Error!',
      text: message,
      icon: 'error',
      confirmButtonText: 'Ok, Got It.',
    });
  }

  HashMismatchError() {
    Swal.fire({
      title: 'Error!',
      text: 'Hash Mismatch Error: The response data is invalid!',
      icon: 'error',
      confirmButtonText: 'Ok, Got It.',
    });
  }

  UnAuthorize() {
    Swal.fire({
      title: 'Error!',
      text: 'Your session has expired. Please log in again.',
      icon: 'error',
      showConfirmButton: false
    })
  }

  confirm(message: string): Promise<any> {
    return Swal.fire({
      title: 'Information',
      text: message,
      icon: 'info',
      allowOutsideClick: false,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel'
    });
  }

  success(message: string): Promise<any> {
    return Swal.fire({
      title: 'Success!',
      text: message,
      icon: 'success',
      confirmButtonText: 'Ok'
    });
  }

  info(message: string): Promise<any> {
    return Swal.fire({
      title: 'Information',
      text: message,
      icon: 'info',
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Got it!',
    });
  }

  confirmApproveLiveness(callback: () => void) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to approve this user?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#28a745',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Yes, approve!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        callback();
      }
    });
  }

  confirmRejectLiveness(callback: () => void) {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#e74c3c', 
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Yes, reject it!',
      cancelButtonText: 'No, cancel!'
    }).then((result) => {
      if (result.isConfirmed) {
        callback();
      }
    });
  }

}
